import { type FC, useEffect, useRef, useState } from 'react'

import classNames from 'classnames'

import { IconCloseXSm } from 'assets/svg/sprite'
import './_processingFile.scss'

interface Props {
  percentage: number
  onAbort: () => void
  className?: string
  text?: string
  hideAbort?: boolean
}

const ProcessingFile: FC<Props> = ({ percentage, onAbort, className, text, hideAbort = false }) => {
  const [smoothPct, setSmoothPct] = useState(0)
  const rafRef = useRef<number | null>(null)

  // Smooth interpolation loop
  useEffect(() => {
    cancelAnimationFrame(rafRef.current!)

    const animate = () => {
      setSmoothPct(prev => {
        // interpolate 10–20% of the way each frame — smooth as butter
        const delta = percentage - prev
        const next = prev + delta * 0.08 // smaller = smoother
        if (Math.abs(delta) < 0.1) return percentage
        return next
      })
      rafRef.current = requestAnimationFrame(animate)
    }

    rafRef.current = requestAnimationFrame(animate)
    return () => cancelAnimationFrame(rafRef.current!)
  }, [percentage])

  return (
    <div className={classNames('processingFile', className)}>
    {!hideAbort && (
      <div className='processingFile__abort' onClick={onAbort}>
        <IconCloseXSm />
      </div>
    )}
      <div className='processingFile__wrapper'>
        <div className='processingFile__loader'>
          <span className='processingFileLoader'></span>
        </div>
      </div>

      <div className='processingFile__progress'>
        <div className='processingFile__text'>{text ?? 'processing'}</div>
        <div className='processingFile__progress--bar'>
          <progress max='100' value={smoothPct}></progress>
        </div>
      </div>
    </div>
  )
}

export default ProcessingFile
